import React from 'react';
import '../styles/soporte.css';

const SoporteTecnico = () => {
  const whatsappNumber = '+573112610669';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}`;

  return (
    <div className="soporte-container">
      <div className="soporte-header">
        <h1>Soporte Técnico</h1>
        <p>Ofrecemos soluciones técnicas especializadas para mantener tu negocio funcionando sin problemas</p>
      </div>

      <div className="soporte-grid">
        <div className="soporte-card">
          <div className="card-icon">
            <span className="material-icons">computer</span>
          </div>
          <div className="card-content">
            <h3>Soporte Remoto</h3>
            <p className="card-description">Asistencia técnica inmediata desde cualquier lugar</p>
            <p className="card-details">
              Nuestro equipo de expertos puede conectarse de forma segura a tus sistemas para resolver problemas técnicos en tiempo real, sin necesidad de desplazamientos.
            </p>
            <p className="card-highlight">Solución rápida y eficiente</p>
            <p className="card-tagline">Tu tranquilidad es nuestra prioridad</p>
          </div>
        </div>

        <div className="soporte-card">
          <div className="card-icon">
            <span className="material-icons">engineering</span>
          </div>
          <div className="card-content">
            <h3>Soporte Presencial</h3>
            <p className="card-description">Atención personalizada en tu ubicación</p>
            <p className="card-details">
              Cuando el problema requiere atención física, nuestro equipo se desplaza a tu ubicación para realizar diagnósticos, reparaciones y mantenimiento in situ.
            </p>
            <p className="card-highlight">Servicio personalizado y directo</p>
            <p className="card-tagline">Estamos donde nos necesites</p>
          </div>
        </div>

        <div className="soporte-card">
          <div className="card-icon">
            <span className="material-icons">support_agent</span>
          </div>
          <div className="card-content">
            <h3>Soporte Telefónico / WhatsApp</h3>
            <p className="card-description">Asesoramiento técnico inmediato</p>
            <p className="card-details">
              Disponibles por teléfono y WhatsApp para guiarte en la resolución de problemas técnicos, proporcionar asesoramiento y responder a tus consultas de manera inmediata.
            </p>
            <p className="card-highlight">Respuesta rápida y efectiva</p>
            <p className="card-tagline">Siempre a tu disposición</p>
          </div>
        </div>
      </div>

      <div className="soporte-contacto">
        <h2>¿Necesitas Ayuda?</h2>
        <div className="contacto-info">
          <div className="info-item">
            <span className="material-icons">phone</span>
            <p>+57 3112610669</p>
          </div>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="info-item">
            <span className="material-icons">whatsapp</span>
            <p>+57 3112610669</p>
          </a>
          <div className="info-item">
            <span className="material-icons">schedule</span>
            <p>Lunes a Viernes: 9:00 - 18:00</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoporteTecnico; 